import { CIMSPage, Permission } from '@cims-online/shared'
import { ProtectedRoute } from '../../../../../components/ProtectedRoute'
import { Switch } from 'react-router-dom'
import Asphalt from './components/Asphalt'
import Concrete from './components/Concrete'

const Materials: React.VFC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[
          CIMSPage.ConcreteMixDesigns.recordPath,
          CIMSPage.ConcreteMixDesigns.projectPath,
        ]}
        permissions={Permission.ViewConcreteMixDesign}
      >
        <Concrete />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.AsphaltMixDesigns.projectPath}
        permissions={[
          Permission.ViewAsphaltMixDesign,
          Permission.ViewLIMSAsphaltMixDesignTarget,
        ]}
      >
        <Asphalt />
      </ProtectedRoute>
    </Switch>
  )
}

export default Materials
